<template>
  <div>
    <div class="main">
      <!-- Right -->
      <div class="main_r">
        <!-- search -->
       <div class="search">
          <div>
            <el-button type="primary" @click="clickBack">返回</el-button>
            <el-select v-model="queryData.dataType" placeholder="数据类型">
              <el-option label="请选择数据类型" value="0"></el-option>
              <el-option label="训练计划" value="1"></el-option>
              <el-option label="单课程" value="2"></el-option>
            </el-select>
            <el-select v-model="queryData.completedStatus" placeholder="完成状态">
              <el-option label="请选择完成状态" value="-1"></el-option>
              <el-option label="未完成" value="0"></el-option>
              <el-option label="已完成" value="1"></el-option>
            </el-select>
            <el-select v-model="queryData.isDelete" placeholder="是否删除">
              <el-option label="请选择是否删除" value="-1"></el-option>
              <el-option label="未删除" value="0"></el-option>
              <el-option label="已删除" value="1"></el-option>
            </el-select>
            <!-- <el-date-picker v-model="queryData.dayDate" type="date" value-format="yyyy-MM-dd" placeholder="日期" class="mr15"></el-date-picker> -->
            <el-button type="primary" @click="clickQuery">查询</el-button>
            <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
          </div>
        </div>
        <!-- search End -->

        <!-- 列表 -->
        <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @sort-change="handleSortChange">
          <el-table-column type="expand" min-width="1%">
            <template slot-scope="props">
              <el-table :data="props.row.list" height="300" class="tableInner" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center',padding: '0' }">
                <el-table-column prop="trainDate" label="训练日期" sortable></el-table-column>
                <el-table-column prop="trainDate" label="第几周" sortable>
                  <template slot-scope="propsSub">
                    第{{propsSub.row.weekId}}周
                  </template>
                </el-table-column>
                <el-table-column prop="trainDate" label="第几天" sortable>
                  <template slot-scope="propsSub">
                    第{{propsSub.row.dayId}}天
                  </template>
                </el-table-column>
                <el-table-column prop="courseId" label="课程编号" sortable></el-table-column>
                <el-table-column prop="completedStatus" label="完成状态" sortable>
                  <template slot-scope="props">
                    <span v-if="props.row.completedStatus == 0">未完成</span>
                    <span v-if="props.row.completedStatus == 1">已完成</span>
                  </template>
                </el-table-column>
                <el-table-column prop="completedPercentage" label="完成百分比" sortable>
                  <template slot-scope="props">
                    {{props.row.completedPercentage}}%
                  </template>
                </el-table-column>
                <el-table-column prop="isDelete" label="训练时长" sortable>
                  <template slot-scope="props">
                    <span v-if="props.row.isDelete == 0">未删除</span>
                    <span v-if="props.row.isDelete == 1">已删除</span>
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="trainPlanOrderid" label="训练单号" min-width="20%" sortable="custom"></el-table-column>
          <el-table-column prop="startDate" label="开始日期" min-width="20%" sortable="custom"></el-table-column>
          <el-table-column prop="dataType" label="训练类型" min-width="10%" sortable="custom">
            <template slot-scope="props">
              <span v-if="props.row.dataType == 1">训练计划</span>
              <span v-if="props.row.dataType == 2">单课程</span>
            </template>
          </el-table-column>
          <el-table-column prop="dataId" label="训练计划编号/课程编号" min-width="10%" sortable="custom"></el-table-column>
          <el-table-column prop="completedStatus" label="完成状态" min-width="10%" sortable="custom">
            <template slot-scope="props">
              <span v-if="props.row.completedStatus == 0">未完成</span>
              <span v-if="props.row.completedStatus == 1">已完成</span>
            </template>
          </el-table-column>
          <el-table-column prop="completedPercentage" label="完成百分比" min-width="10%" sortable="custom">
            <template slot-scope="props">
              {{props.row.completedPercentage}}%
            </template>
          </el-table-column>
          <el-table-column prop="isDelete" label="删除状态" min-width="10%" sortable="custom">
            <template slot-scope="props">
              <span v-if="props.row.isDelete == 0">未删除</span>
              <span v-if="props.row.isDelete == 1">已删除</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="20%" sortable="custom"></el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="mt20">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page_no"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="5"
            layout="prev, pager, next, sizes, jumper "
            :total="dataListnum">
          </el-pagination>
        </div>
        <!-- 分页 End -->
      </div>
      <!-- Right End -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {},
  data () {
    return {
      queryData: {
        dataType: '0',
        completedStatus: '-1',
        isDelete: '-1',
        terminalUserId: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 5,
      sortField: '',
      sortOrder: ''
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.queryData.terminalUserId = row.id
      this.TrainPlanMyList()
      this.TrainPlanMyNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.TrainPlanMyList()
      this.TrainPlanMyNum()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.TrainPlanMyList()
      this.TrainPlanMyNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.TrainPlanMyList()
      this.TrainPlanMyNum()
    },
    clickQuery () {
      this.page_no = 1
      this.TrainPlanMyList()
      this.TrainPlanMyNum()
      console.log(this.queryData)
    },
    clickQueryReset () {
      this.queryData.dataType = '0'
      this.queryData.completedStatus = '-1'
      this.queryData.isDelete = '-1'
      this.clickQuery()
    },
    clickBack () {
      this.$emit('triggerFunc', '')
    },
    TrainPlanMyList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.dataType = that.queryData.dataType
      data.completedStatus = that.queryData.completedStatus
      data.isDelete = that.queryData.isDelete
      data.terminalUserId = that.queryData.terminalUserId
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanMyList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
          console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    TrainPlanMyNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.dataType = that.queryData.dataType
      data.completedStatus = that.queryData.completedStatus
      data.isDelete = that.queryData.isDelete
      data.terminalUserId = that.queryData.terminalUserId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainPlanMyNum, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 300px;
    margin-right: 15px;
  }

  .el-select{
    margin-right: 15px;
  }

  .el-button{
    margin-left: 10px;
    margin-right: 10px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }

    .el-button{
      margin-left: 10px;
      margin-right: 10px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}
</style>
